"use client";

import { DetailText, LeadText, Link } from "@gnist/design-system";
import { styled } from "styled-components";
import { NotFoundIcon } from "../../../../components/icons";
import { tokens } from "@gnist/themes/tokens.css.js";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.xxl};

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.xxs};

  align-items: center;
`;

const StyledDescription = styled(DetailText)`
  text-align: center;
`;

const StyledLink = styled(Link)`
  display: inline-flex;
  font-weight: ${tokens.typeface.weight.semibold};
  text-decoration: none;
`;

const NotFound = () => {
  return (
    <Wrapper>
      <NotFoundIcon />
      <TextContainer>
        <LeadText>Vi finner ikke bilen du ser etter</LeadText>
        <StyledDescription>
          … men kanskje du finner en bil som passer deg enda bedre?
          <br />
          Gå til forsiden for å se alle våre bruktbiler.
        </StyledDescription>
        <StyledLink href="/">Gå til forsiden</StyledLink>
      </TextContainer>
    </Wrapper>
  );
};

export default NotFound;
